<div class="d-flex is-vertical-align" [ngStyle]="contentStyle" *ngIf="isBackendValuesMode()">
  <div class="d-flex is-space-between mb-5">
    <div [style.color]="labelTextColor">Number</div>
    <div class="d-flex mr-4">
      <div class="mr-1" [style.color]="detailsTextColor">{{ secureCVVDetails.pan }}</div>
      <div>
        <finxone-web-frontend-copy-share
          [useCustomTemplate]="true"
          [textContentTemplate]="''"
          [leftIcon]="copyIcon"
          [leftIconStyle]="iconStyle"
          [copyContentTemplate]="panCopyTemplate"
          (copyContentValue)="copyContent($event, CardsSuccessCodes.CARD_NUMBER_COPIED)"
        ></finxone-web-frontend-copy-share>
      </div>
    </div>
  </div>
  <div class="d-flex is-space-between mb-5">
    <div [style.color]="labelTextColor">Expiry Date</div>
    <div class="d-flex mr-4">
      <div class="mr-1" [style.color]="detailsTextColor">{{ secureCVVDetails.expDate }}</div>
      <finxone-web-frontend-copy-share
        [useCustomTemplate]="true"
        [textContentTemplate]="''"
        [leftIcon]="copyIcon"
        [leftIconStyle]="iconStyle"
        [copyContentTemplate]="expiryCopyTemplate"
        (copyContentValue)="copyContent($event, CardsSuccessCodes.CARD_EXP_DATE_COPIED)"
      ></finxone-web-frontend-copy-share>
    </div>
  </div>
  <div class="d-flex is-space-between mb-5">
    <div [style.color]="labelTextColor">CVV</div>
    <div class="d-flex mr-4">
      <div class="mr-1" [style.color]="detailsTextColor">{{ secureCVVDetails.cvv2 }}</div>
      <finxone-web-frontend-copy-share
        [useCustomTemplate]="true"
        [textContentTemplate]="''"
        [leftIcon]="copyIcon"
        [leftIconStyle]="iconStyle"
        [copyContentTemplate]="cvv2CopyTemplate"
        (copyContentValue)="copyContent($event, CardsSuccessCodes.CARD_CVV_COPIED)"
      ></finxone-web-frontend-copy-share>
    </div>
  </div>
  <div class="d-flex is-space-between">
    <div [style.color]="labelTextColor">Card Type</div>
    <div [style.color]="detailsTextColor">{{ cardType }}</div>
  </div>
</div>
<div class="d-flex is-vertical-align" [ngStyle]="contentStyle" *ngIf="isAirwallexIframeMode()">
  <div [id]="airwallexIframeHostId" class="w-100"></div>
  <div class="d-flex is-space-between mt-5">
    <div [style.color]="labelTextColor">Card Type</div>
    <div [style.color]="detailsTextColor">{{ cardType }}</div>
  </div>
</div>
<div class="d-flex is-vertical-align" [ngStyle]="contentStyle" *ngIf="isProviderSdkMode()">
  <div class="d-flex is-space-between mb-5">
    <div [style.color]="labelTextColor">Number</div>
    <div class="d-flex mr-4 align-items-center">
      <div class="mr-1" [style.color]="detailsTextColor">
        <div [id]="panSdkDomId"></div>
      </div>
      <div [id]="copyPanSdkDomId" style="position: relative">
        <mat-icon [ngStyle]="iconStyle" [svgIcon]="copyIcon"></mat-icon>
      </div>
    </div>
  </div>
  <div class="d-flex is-space-between mb-5">
    <div [style.color]="labelTextColor">Expiry Date</div>
    <div class="d-flex mr-4 align-items-center">
      <div class="mr-1" [style.color]="detailsTextColor">
        <div [id]="expSdkDomId"></div>
      </div>
      <div [id]="copyExpSdkDomId" style="position: relative">
        <mat-icon [ngStyle]="iconStyle" [svgIcon]="copyIcon"></mat-icon>
      </div>
    </div>
  </div>
  <div class="d-flex is-space-between mb-5">
    <div [style.color]="labelTextColor">CVV</div>
    <div class="d-flex mr-4 align-items-center">
      <div class="mr-1" [style.color]="detailsTextColor">
        <div [id]="cvvSdkDomId"></div>
      </div>
      <div [id]="copyCvvSdkDomId" style="position: relative">
        <mat-icon [ngStyle]="iconStyle" [svgIcon]="copyIcon"></mat-icon>
      </div>
    </div>
  </div>
  <div class="d-flex is-space-between">
    <div [style.color]="labelTextColor">Card Type</div>
    <div [style.color]="detailsTextColor">{{ cardType }}</div>
  </div>
</div>
<div *ngIf="providerSdkError" [ngStyle]="contentStyle">
  <div [style.color]="labelTextColor">{{ providerSdkError }}</div>
</div>
<div *ngIf="isDataFetching(secureCVVDetails) || providerSdkLoading" class="d-flex is-space-between">
  <div>
    <finxone-web-frontend-text-skeleton contentClass="w-40 h-[1em] mb-5 rounded-[5px]" />
    <finxone-web-frontend-text-skeleton contentClass="w-48 h-[1em] mb-5 rounded-[5px]" />
    <finxone-web-frontend-text-skeleton contentClass="w-20 h-[1em] mb-5 rounded-[5px]" />
    <finxone-web-frontend-text-skeleton contentClass="w-32 h-[1em] mb-5 rounded-[5px]" />
  </div>
  <div class="text-right">
    <finxone-web-frontend-text-skeleton contentClass="w-80 h-[1em] mb-5 ml-auto rounded-[5px]" />
    <finxone-web-frontend-text-skeleton contentClass="w-20 h-[1em] mb-5 ml-auto rounded-[5px]" />
    <finxone-web-frontend-text-skeleton contentClass="w-12 h-[1em] mb-5 ml-auto rounded-[5px]" />
    <finxone-web-frontend-text-skeleton contentClass="w-32 h-[1em] mb-5 ml-auto rounded-[5px]" />
  </div>
</div>
